/* eslint-disable */
<template>
  <!-- eslint-disable -->
  <b-container fluid>
    <b-form @submit="updateIndex" novalidate>
      <header
        class="d-flex justify-content-center align-items-center mt-5 mb-3"
      >
        <h1>
          <span v-if="index._id">Edit</span>
          <span v-else>Add New</span>
          Patient Record
        </h1>
        <b-button type="submit" variant="primary" class="ml-auto"
          >Save</b-button
        >
      </header>

      <b-alert size="sm" :show="alert.show" :variant="alert.type">{{
        alert.name
      }}</b-alert>

      <h2>General Information</h2>
      <b-card bg-variant="light">
        <b-form-group
          label="Identifier"
          description="Provide a unique name or title for this medical record."
          label-cols="2"
          label-for="index-identifier"
        >
          <b-form-input
            id="index-identifier"
            v-model="index.identifier"
            :state="valid.identifier"
            required
          ></b-form-input>

          <b-form-invalid-feedback :state="valid.identifier">
            <strong>Identifier</strong> is a required field, please provide a
            value.
          </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group
          label="Name"
          description="Provide a descriptive display name for future retrieval purposes."
          label-cols="2"
          label-for="index-name"
          class="mb-0"
        >
          <b-form-input
            id="index-name"
            v-model="index.name"
            :state="valid.name"
            required
          ></b-form-input>

          <b-form-invalid-feedback :state="valid.name">
            <strong>Name</strong> is a required field, please provide a value.
          </b-form-invalid-feedback>
        </b-form-group>
      </b-card>

      <h2>Patient Categories</h2>
      <section class="categories-layout">
        <aside class="categories-layout__add-more">
          <b-card bg-variant="light" title="Add More">
            <b-form-group
              class="select-category"
              label-cols="2"
              label-for="category-definitions"
            >
              <div id="category-definitions" class="list-group-filtered">
                <b-form-input
                  v-model="search"
                  placeholder="Find categories…"
                ></b-form-input>

                <b-list-group>
                  <b-list-group-item
                    v-for="categoryDefinition in filteredCategoryDefinitions"
                    :key="categoryDefinition._id"
                  >
                    <b-link
                      block
                      @click="selectCategoryDefinition(categoryDefinition)"
                    >
                      {{ categoryDefinition.display_name }}
                    </b-link>
                    {{ categoryDefinition.description }}
                  </b-list-group-item>
                </b-list-group>
              </div>
            </b-form-group>
          </b-card>
        </aside>

        <div class="categories-layout__selections">
          <b-card title="Selections" bg-variant="light">
            <div
              v-if="selectedCategoryDefinitions.length > 0"
              v-for="(selectedCategoryDefinition,
              i) in selectedCategoryDefinitions"
              :key="selectedCategoryDefinition._id"
            >
              <CategoryAttributeForm
                :all_categories="[]"
                :ordinal="i"
                :level="parseInt(1)"
                :key="selectedCategoryDefinition._id"
                :attribute_key="selectedCategoryDefinition.key"
                :category="selectedCategoryDefinition"
              />
            </div>

            <div v-else></div>
          </b-card>
        </div>
      </section>
    </b-form>
  </b-container>
</template>
<script>
/* eslint-disable */
import { API } from "../../api";
import { debounce, isEmpty, each, every, values } from "lodash";
// import CategoryAttributeForm from './CategoryAttributeForm'
import { mapState } from "vuex";
const api = new API();
const wolfram = {
  appName: "RADECT",
  appId: "LTV4W7-RP3GX4T4T8"
};

export default {
  name: "EditIndex",
  data() {
    return {
      index: {
        _id: null,
        identifier: null,
        name: null
      },
      valueCategories: [],
      selectedCategoryDefinitions: [],
      filteredCategoryDefinitions: [],
      search: null,
      alert: {
        text: "",
        show: false,
        type: "success"
      },
      valid: {
        identifier: null,
        name: null
      }
    };
  },
  methods: {
    getIndex(id, allCategoryDefinitions) {
      api
        .findOne("indexes", { _id: id })
        .then(response => {
          const index = response.data;
          this.index._id = index._id;
          this.index.identifier = index.identifier;
          this.index.name = index.name;
          this.$store.commit("setCategories", index.categories);
          let missing_categories = [];
          each(index.categories, category => {
            let selectedCategoryDefinition =
              allCategoryDefinitions[category.category_id];
            if (selectedCategoryDefinition) {
              this.selectedCategoryDefinitions.push(selectedCategoryDefinition);
            } else {
              missing_categories.push(category.display_name);
            }
          });
          if (missing_categories && missing_categories.join().trim() !== "") {
            this.alert.name =
              "This index has categories that have been removed: " +
              missing_categories.join(", ");
            this.alert.show = true;
          }
        })
        .catch(error => {
          console.error(error);
          this.showErrorMessage("Error loading index: " + error);
        });
    },
    updateIndex($event) {
      $event.preventDefault();

      // Validate
      this.valid.name = !isEmpty(this.index.name);
      this.valid.identifier = !isEmpty(this.index.identifier);

      // Halt if any fields are invalid
      const allValid = every(values(this.valid), val => {
        return val === true;
      });
      if (!allValid) return;

      const index = {
        identifier: this.index.identifier,
        name: this.index.name,
        categories: this.$store.state.categories
      };

      api
        .updateIndex(index, this.index._id)
        .then(response => {
          this.alert.name = "Saved";
          this.alert.show = true;
          setTimeout(() => {
            this.$router.go();
          }, 500);
        })
        .catch(error => {
          this.showErrorMessage(error);
        });
    },
    selectCategoryDefinition(category) {
      this.selectedCategoryDefinitions.push(category);
    },
    showErrorMessage(msg) {
      this.alert.name = msg;
      this.alert.show = true;
      this.alert.type = "danger";
    },
    filterCategoryDefinitions: debounce(function(allCategoryDefinitions) {
      let me = this;
      me.filteredCategoryDefinitions = [];
      if (!allCategoryDefinitions) {
        allCategoryDefinitions = this.$store.getters
          .getAllCategoryDefinitionsById;
      }
      each(allCategoryDefinitions, function(categoryDefinition) {
        if (
          !me.search ||
          (categoryDefinition.display_name &&
            categoryDefinition.display_name
              .toLowerCase()
              .includes(me.search.toLowerCase()))
        ) {
          me.filteredCategoryDefinitions.push(categoryDefinition);
        }
      });
    }, 1000),

    // Gets all of the categories first, then gets the index
    getCategoryDefinitionsById() {
      api
        .getCategoryDefinitionsById()
        .then(allCategoryDefinitions => {
          this.filteredCategoryDefinitions = allCategoryDefinitions;
          if (this.$route.params.id) {
            this.getIndex(this.$route.params.id, allCategoryDefinitions);
          }
        })
        .catch(error => {
          console.error(error);
          this.alert.name = "Error loading cat defs";
          this.alert.show = true;
        });
    }
  },
  watch: {
    search: function(val) {
      this.filterCategoryDefinitions();
    }
  },
  mounted() {
    this.getCategoryDefinitionsById();
  }
};
</script>

<style scoped>
hr {
  margin: 30px 0 25px;
}
h2 {
  font-size: 24px;
  line-height: 1;
  color: #666;
  margin: 30px 0 10px;
}
.categories-layout {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-content: stretch;
  align-items: stretch;
  width: 100%;
}
.categories-layout__add-more {
  flex: 0 1 auto;
  align-self: auto;
  display: block;
  width: 25%;
}
.categories-layout__selections {
  flex: 1;
  margin-left: 30px;
  align-self: stretch;
}
.select-category {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-content: stretch;
  align-items: stretch;
  height: 100%;
  margin: 0;
}
.select-category >>> label {
  color: #18a2b8;
  font-size: 18px;
  font-weight: bold;
  line-height: 24px;
  padding-top: 4px !important;
  display: block;
  flex: 0 1 auto;
}
.select-category >>> label + div {
  flex: 1 1 auto;
}
.card-title {
  margin: -20px -20px 20px;
  padding: 10px 20px;
  background-color: #18a2b8;
  border-radius: 3px 3px 0 0;
  font-size: 14px;
  text-transform: uppercase;
  font-weight: 600;
  line-height: 1;
  color: white;
}
.card-body {
  padding: 20px;
  border-radius: 4px;
}
.card-body > div + div {
  margin-top: 20px;
}
.list-group-filtered {
  margin: -30px -25px -20px;
  border-radius: 0;
}
.list-group-filtered input {
  margin-bottom: 0;
  border-radius: 0;
  border: none;
  line-height: 1;
  padding: 10px 20px;
  height: auto;
  position: relative;
  z-index: 2;
}
.list-group-filtered .list-group {
  overflow-y: scroll;
  max-height: 350px;
  margin-top: 0;
  border: none;
  border-radius: 0;
}
.list-group-filtered .list-group-item {
  padding: 10px 20px;
  border-color: #e3e3e3;
  line-height: 1;
  border-left: none;
  border-right: none;
}
.list-group-filtered .list-group-item:first-child {
  border-radius: 0;
}
.list-group-filtered .list-group-item:last-child {
  border-radius: 0;
}
.list-group-filtered .list-group-item:nth-child(odd) {
  background-color: #fafafa;
}
.list-group-filtered .list-group-item:nth-child(even) {
  background-color: #f0f0f0;
}
</style>
